// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Label = require("../common/Components/Label.bs.js");
let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let Tooltip = require("../../reason/common/Tooltip.bs.js");
let UTCDate = require("../../reason/common/types/UTCDate.bs.js");
let DateIcon = require("../common/Components/DateIcon.bs.js");
let DateFns = require("date-fns");
let AgentInfo = require("../common/Agent/AgentInfo.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let FeatureGate = require("../../reason/subscription/FeatureGate.bs.js");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let ShowingsUtils = require("../common/ShowingsUtils.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let PropertyMlsLabel = require("../property/PropertyMlsLabel.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let AnonymousForSalePropertyAgentInfo = require("../client/ClientPage/AnonymousForSalePropertyAgentInfo.bs.js");
let ShowingsPageRelayShowingsByDay_showing_graphql = require("../../__generated__/ShowingsPageRelayShowingsByDay_showing_graphql.bs.js");
let ShowingsPageRelayShowingsByDay_showings_graphql = require("../../__generated__/ShowingsPageRelayShowingsByDay_showings_graphql.bs.js");

let convertFragment = ShowingsPageRelayShowingsByDay_showings_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ShowingsPageRelayShowingsByDay_showings_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ShowingsPageRelayShowingsByDay_showings_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(fRef) : undefined, ShowingsPageRelayShowingsByDay_showings_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ShowingsPageRelayShowingsByDay_showings_graphql.node, convertFragment, fRef);
}

let ShowingsFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = ShowingsPageRelayShowingsByDay_showing_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ShowingsPageRelayShowingsByDay_showing_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ShowingsPageRelayShowingsByDay_showing_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ShowingsPageRelayShowingsByDay_showing_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ShowingsPageRelayShowingsByDay_showing_graphql.node, convertFragment$1, fRef);
}

let ShowingFragment_showingTypeV5_decode = ShowingsPageRelayShowingsByDay_showing_graphql.Utils.showingTypeV5_decode;

let ShowingFragment_showingTypeV5_fromString = ShowingsPageRelayShowingsByDay_showing_graphql.Utils.showingTypeV5_fromString;

let ShowingFragment_visibilityReason_decode = ShowingsPageRelayShowingsByDay_showing_graphql.Utils.visibilityReason_decode;

let ShowingFragment_visibilityReason_fromString = ShowingsPageRelayShowingsByDay_showing_graphql.Utils.visibilityReason_fromString;

let ShowingFragment = {
  showingTypeV5_decode: ShowingFragment_showingTypeV5_decode,
  showingTypeV5_fromString: ShowingFragment_showingTypeV5_fromString,
  visibilityReason_decode: ShowingFragment_visibilityReason_decode,
  visibilityReason_fromString: ShowingFragment_visibilityReason_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function ShowingsPageRelayShowingsByDay$Showing(props) {
  let showing = RescriptRelay_Fragment.useFragment(ShowingsPageRelayShowingsByDay_showing_graphql.node, convertFragment$1, props.showing);
  let chapterTimezone = UserSession.useChapterTimezone();
  let match = showing.type_;
  let badgeText;
  if (match === "AGENTS_ONLY" || match === "TAN_ONLY" || match === "BUYERS_WELCOME") {
    switch (match) {
      case "AGENTS_ONLY" :
        badgeText = "Agents only";
        break;
      case "BUYERS_WELCOME" :
        badgeText = "Buyers welcome";
        break;
      case "TAN_ONLY" :
        badgeText = "TAN only";
        break;
    }
  } else {
    badgeText = undefined;
  }
  let alsoShowingOn = Stdlib_Array.filterMap(Stdlib_Option.getOr(Stdlib_Option.map(showing.property.showings, v => v.edges), []), v => {
    if (v === undefined) {
      return;
    }
    let node = v.node;
    if (node.id !== showing.id && UTCDate.isAfter(Scalars.DateTime.toUTC(node.startDate), UTCDate.now())) {
      return node;
    }
  });
  let showPropertyDetails = UserSession.useShouldShowPropertyDetails(Stdlib_Option.flatMap(showing.property.agentV2, a => {
    switch (a.__typename) {
      case "VisibleForSalePropertyAgent" :
        return a.agent.id;
      case "AnonymousForSalePropertyAgent" :
      case "__unselected" :
        return;
    }
  }));
  let match$1 = showing.property.propertyLocation;
  let tmp;
  if (showPropertyDetails) {
    if (match$1 !== undefined) {
      switch (match$1.__typename) {
        case "PropertyLocationWithHiddenAddress" :
          let locationDisplay = match$1.locationDisplay;
          tmp = locationDisplay !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("div", {
                  children: locationDisplay,
                  className: "text-lg md:text-xl"
                }),
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(IconV5.make, {
                        icon: "lock",
                        size: 16,
                        className: "text-gray-600 mr-1"
                      }),
                      JsxRuntime.jsx("div", {
                        children: "Contact agent for address"
                      })
                    ],
                    className: "flex flex-row items-center lg:before:content-['('] lg:after:content-[')'] before:content-none after:content-none"
                  }),
                  className: "text-gray-600 text-lg"
                })
              ]
            }) : null;
          break;
        case "PropertyLocationWithVisibleAddress" :
          let address = match$1.address;
          if (address !== undefined) {
            let locationDisplay$1 = match$1.locationDisplay;
            if (locationDisplay$1 !== undefined) {
              let visibilityRule = match$1.visibilityRule;
              if (visibilityRule !== undefined) {
                let exit = 0;
                if (visibilityRule === "VISIBLE_TO_ACCOUNT_MEMBER" || visibilityRule === "VISIBLE_TO_TAN_STAFF" || visibilityRule === "VISIBLE_TO_ALL") {
                  switch (visibilityRule) {
                    case "VISIBLE_TO_ALL" :
                      tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {
                        children: JsxRuntime.jsx("div", {
                          children: address + `, ` + locationDisplay$1,
                          className: "text-lg md:text-xl"
                        })
                      });
                      break;
                    case "VISIBLE_TO_ACCOUNT_MEMBER" :
                    case "VISIBLE_TO_TAN_STAFF" :
                      exit = 1;
                      break;
                  }
                } else {
                  tmp = null;
                }
                if (exit === 1) {
                  tmp = JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                        children: locationDisplay$1,
                        className: "text-lg md:text-xl"
                      }),
                      JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Tooltip.make, {
                          ariaLabel: address,
                          label: address + ` (only visible to ` + (
                            visibilityRule === "VISIBLE_TO_ACCOUNT_MEMBER" ? "you" : "TAN staff"
                          ) + `)`,
                          children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(IconV5.make, {
                                icon: "lock",
                                size: 16,
                                className: "text-gray-600 mr-1"
                              }),
                              JsxRuntime.jsx("div", {
                                children: "Hidden address"
                              })
                            ],
                            className: "flex flex-row items-center lg:before:content-['('] lg:after:content-[')'] before:content-none after:content-none"
                          })
                        }),
                        className: "text-gray-600 text-lg"
                      })
                    ],
                    className: "flex flex-col md:flex-row"
                  });
                }
              } else {
                tmp = null;
              }
            } else {
              tmp = null;
            }
          } else {
            tmp = null;
          }
          break;
        case "__unselected" :
          tmp = null;
          break;
      }
    } else {
      tmp = null;
    }
  } else if (match$1 !== undefined) {
    let exit$1 = 0;
    let locationDisplay$2;
    switch (match$1.__typename) {
      case "PropertyLocationWithHiddenAddress" :
        let locationDisplay$3 = match$1.locationDisplay;
        if (locationDisplay$3 !== undefined) {
          locationDisplay$2 = locationDisplay$3;
          exit$1 = 1;
        } else {
          tmp = null;
        }
        break;
      case "PropertyLocationWithVisibleAddress" :
        let locationDisplay$4 = match$1.locationDisplay;
        if (locationDisplay$4 !== undefined) {
          locationDisplay$2 = locationDisplay$4;
          exit$1 = 1;
        } else {
          tmp = null;
        }
        break;
      case "__unselected" :
        tmp = null;
        break;
    }
    if (exit$1 === 1) {
      tmp = JsxRuntime.jsx("div", {
        children: locationDisplay$2,
        className: "text-xl font-medium text-gray-800",
        title: locationDisplay$2
      });
    }
  } else {
    tmp = null;
  }
  let notes = showing.notes;
  let match$2 = showing.property.agentV2;
  let tmp$1;
  if (match$2 !== undefined) {
    switch (match$2.__typename) {
      case "AnonymousForSalePropertyAgent" :
        tmp$1 = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(AnonymousForSalePropertyAgentInfo.make, {
            agent: match$2.fragmentRefs,
            size: "medium"
          })
        });
        break;
      case "VisibleForSalePropertyAgent" :
        tmp$1 = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(AgentInfo.make, {
            agent: match$2.agent.fragmentRefs
          })
        });
        break;
      case "__unselected" :
        tmp$1 = null;
        break;
    }
  } else {
    tmp$1 = null;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              badgeText !== undefined ? JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(Label.Neutral.make, {
                    text: badgeText
                  }),
                  className: "mb-1"
                }) : null,
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(PropertyMlsLabel.make, {
                  property: showing.property.fragmentRefs
                }),
                className: "block md:hidden"
              })
            ],
            className: "flex flex-row gap-3"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ButtonsV5.Link.make, {
              href: "/properties/" + showing.property.id,
              className: "text-gray-900",
              children: JsxRuntime.jsxs("div", {
                children: [
                  tmp,
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(PropertyMlsLabel.make, {
                      property: showing.property.fragmentRefs
                    }),
                    className: "hidden md:block"
                  })
                ],
                className: "flex flex-row space-x-4 text-3xl items-center"
              })
            }),
            className: "flex flex-row space-x-4 relative"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: ShowingsUtils.formatShowingTimes(showing.startDateV2, showing.endDateV2),
              className: "text-md md:text-lg text-gray-700"
            }),
            className: "flex flex-row space-x-2 text-left"
          })
        ],
        className: "flex flex-col gap-2 md:gap-0"
      }),
      JsxRuntime.jsx(FeatureGate.PropertyDetailsGate.make, {
        children: notes !== undefined ? JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: notes,
              className: "whitespace-pre-line text-gray-700"
            })
          }) : null
      }),
      alsoShowingOn.length !== 0 ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: "Also showing on: ",
              className: "text-left text-gray-700"
            }),
            JsxRuntime.jsx("div", {
              children: alsoShowingOn.map((showing, i) => {
                let match = (alsoShowingOn.length - 1 | 0) - i | 0;
                return JsxRuntime.jsxs("span", {
                  children: [
                    JsxRuntime.jsx(ButtonsV5.Link.make, {
                      href: "/properties/" + (showing.property.id + "#showings"),
                      children: DateFns.format(UTCDate.toZonedDate(Scalars.DateTime.toUTC(showing.startDate), chapterTimezone), "LLL d")
                    }),
                    match !== 0 ? (
                        match !== 1 ? JsxRuntime.jsx("span", {
                            children: ", "
                          }) : JsxRuntime.jsx("span", {
                            children: " and "
                          })
                      ) : null
                  ]
                }, showing.id);
              })
            })
          ],
          className: "flex flex-row space-x-1"
        }) : null,
      tmp$1
    ],
    className: "bg-white flex flex-col gap-4 items-start"
  });
}

let Showing = {
  ShowingFragment: ShowingFragment,
  make: ShowingsPageRelayShowingsByDay$Showing
};

function ShowingsPageRelayShowingsByDay(props) {
  let date = props.date;
  console.log(date);
  let showings = RescriptRelay_Fragment.useFragment(ShowingsPageRelayShowingsByDay_showings_graphql.node, convertFragment, props.showings);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(DateIcon.FromPlainDate.make, {
            date: date
          }),
          className: "mr-7 mb-5"
        }),
        JsxRuntime.jsx("div", {
          children: showings.map((showing, index) => JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ShowingsPageRelayShowingsByDay$Showing, {
              showing: showing.fragmentRefs
            }),
            className: TailwindMerge.twMerge([
              "pt-8",
              index === 0 ? "pt-0" : ""
            ])
          }, showing.id)),
          className: "grow divide-y divide-gray-200 flex flex-col gap-8"
        })
      ],
      className: "flex flex-row items-stretch"
    }),
    className: "border p-5 rounded"
  });
}

let Card;

let make = ShowingsPageRelayShowingsByDay;

exports.Card = Card;
exports.ShowingsFragment = ShowingsFragment;
exports.Showing = Showing;
exports.make = make;
/* Label Not a pure module */
